import cloneDeep from 'lodash/cloneDeep';
import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';
import { Serializable } from './serializable.model';

export class ContentImage implements Deserializable<any, ContentImage>, Serializable<JsonObject> {
  constructor(
    public url?: string,
    public fileName?: string,
    public contentType?: string,
    public title?: string,
    public description?: string,
    public size?: number,
    public width?: number,
    public height?: number
  ) {}

  deserialize(json: any) {
    const isContentImage = json instanceof ContentImage;
    if (!isContentImage && (json == null || json['file'] == null)) {
      return null;
    }
    const file = isContentImage ? json : json['file'];
    const details = isContentImage ? json : file?.['details'] ?? {};
    const image = isContentImage ? json : details?.['image'] ?? {};

    this.url = file['url'];
    this.fileName = file['fileName'];
    this.contentType = file['contentType'];
    this.title = json['title'] ?? '';
    this.description = json['description'] ?? json['altText'] ?? '';
    this.size = details['size'] ?? 0;
    this.width = image['width'] ?? 0;
    this.height = image['height'] ?? 0;

    return this;
  }

  clone(contentImage: ContentImage) {
    return cloneDeep(contentImage);
  }

  serialize() {
    return {
      file: {
        url: this.url,
        details: {
          size: this.size,
          image: {
            width: this.width,
            height: this.height,
          },
        },
        fileName: this.fileName,
        contentType: this.contentType,
      },
      title: this.title,
      description: this.description,
    };
  }
}
